var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongCuowutishiMian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.7V9",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 11.1a.6.6 0 11-1.2 0 .6.6 0 011.2 0z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjciIGZpbGw9IiMzRjQ2NUMiLz4KPHBhdGggZD0iTTggNC42OTk5NVY4Ljk5OTk0IiBzdHJva2U9IndoaXRlIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTguNjAwMDIgMTEuMUM4LjYwMDAyIDExLjQzMTQgOC4zMzE0IDExLjcgOC4wMDAwMiAxMS43QzcuNjY4NjUgMTEuNyA3LjQwMDAyIDExLjQzMTQgNy40MDAwMiAxMS4xQzcuNDAwMDIgMTAuNzY4NiA3LjY2ODY1IDEwLjUgOC4wMDAwMiAxMC41QzguMzMxNCAxMC41IDguNjAwMDIgMTAuNzY4NiA4LjYwMDAyIDExLjFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgTongyongCuowutishiMian as ReactComponent };